import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_reaction",
  "use": "svg_reaction-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"svg_reaction\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 11.162H0v3.04c0 1.115.9 2.027 2 2.027h3v-2.027H2v-3.04ZM2 2.042h3V.016H2c-1.1 0-2 .912-2 2.026v3.04h2v-3.04ZM14 .016h-3v2.026h3v3.04h2v-3.04c0-1.114-.9-2.026-2-2.026ZM14 14.202h-3v2.027h3c1.1 0 2-.912 2-2.027v-3.04h-2v3.04Z\" fill=\"currentColor\" /><path opacity=\".2\" fill=\"currentColor\" d=\"M1 1h14v14H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol